import React from "react";

interface LivePillProps {
  label?: string;
  count?: number;
  suffix?: string;
}

export const LivePill: React.FC<LivePillProps> = ({ label, count, suffix }) => (
  <div className="ds-live-pill">
    <span className="ds-live-dot" />
    {label ?? (
      <>
        {count != null && <span className="tabular">{count}</span>}
        {suffix ?? "online"}
      </>
    )}
  </div>
);
